import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import Leadfunnel from '@/components/leadfunnel';
import Qid from '@/utils/qid';
import convertReady from '@/utils/convert-ready';
import { store, persistor } from '@/redux/store';
import '@/styles/fonts.css';
import '@/styles/general.css';
import '@/styles/modals.css';
import '@/styles/variables-v2.css';
import '@/assets/styles/colors-v2.css';

void convertReady().then(() => {
  // Convert has decided (or the hold timed out): fold the active experiences into the QID cookie
  // before mounting, so useStoreQidData reads them on the first render. Qid's own
  // `snippet.experiences_evaluated` listener stays as the safety net for a late evaluation — it is
  // pushed at module-eval time and can miss an event that already fired. Both writes merge by
  // experimentId, so running twice is a no-op. `new Qid()` returns the singleton app.jsx created.
  new Qid().updateCampaignsWithFreshConvertData();

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <Provider store={store}>
        <PersistGate persistor={persistor} loading={null}>
          <Leadfunnel />
        </PersistGate>
      </Provider>
    </StrictMode>,
  );
});
